import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetDataSourceStatsQuery } from '@/services/dataSources';
import { FC } from 'react';
import { FISCAL_CODE_TRAIT_ID } from '../constants';

/** Citizens (or, with `metric='events'`, received events) count of a single-datasource list, from the datasource stats. */
export const CitizensCount: FC<{ datasourceId?: string; metric?: 'users' | 'events'; className?: string }> = ({
  datasourceId,
  metric = 'users',
  className,
}) => {
  const { id: workspaceId } = useWorkspace();
  const { data } = useGetDataSourceStatsQuery({ workspaceId, dataSourceId: datasourceId ?? '', traitId: FISCAL_CODE_TRAIT_ID }, { skip: !datasourceId });
  const count = data?.[metric];
  return <span className={`tabular-nums ${className ?? ''}`}>{datasourceId && count != null ? count : '—'}</span>;
};
